export default __webpack_public_path__ + "static/media/Home365_Logo.20581b92.svg";